export { default } from "./Slider.js";
export * from "./Slider.js";
export { default as sliderClasses } from "./sliderClasses.js";
export * from "./sliderClasses.js";